import { ReactElement, useEffect, useRef, useState, memo } from "react";
import { useComponentVisible } from "hooks/useComponentVisible";
import { parsiMapSearchAddress } from "api/map/mapApis";
import { CloseIconOutline, SearchIconOutline } from "../icons";
import { colors } from "configs/Theme";
import { useDispatch } from "react-redux";

interface Props {
  setViewPort?: any;
}

function MapSearch({ setViewPort }: Props): ReactElement {
  const mapSearchRef = useRef(null);
  const [state, setState] = useState({
    searchLocation: "",
    searchLocationResults: [],
    typingTimeout: 0,
  });
  const [visible, setVisible] = useState<boolean>(false);
  const { targetComponentRef } = useComponentVisible(false, mapSearchRef);

  const resetState = () => {
    setState({
      searchLocation: "",
      searchLocationResults: [],
      typingTimeout: 0,
    });
    setVisible(false);
  };

  const handleOutsideClick = (event: any) => {
    if (mapSearchRef.current && !mapSearchRef.current.contains(event.target)) {
      resetState();
    }
  };

  const handleChangeSearchLocation = (e) => {
    const value = e.target.value;
    setState((prevState) => ({
      ...prevState,
      searchLocation: value,
    }));

    if (state.typingTimeout) {
      clearTimeout(state.typingTimeout);
    }

    setState((prevState) => ({
      ...prevState,
      typingTimeout: window.setTimeout(async () => {
        if (value.length > 0) {
          const data = await parsiMapSearchAddress({
            district: "تهران",
            search_text: value,
          });

          const searchLocationResults = data?.results || [];
          setState((prevState) => ({
            ...prevState,
            searchLocationResults,
          }));
          setVisible(true);
        } else {
          setVisible(false);
        }
      }, 500),
    }));
  };

  const handleSelectLocation = (location) => {
    const latLng = [location?.geo_location?.center?.lat, location?.geo_location?.center?.lng];
    setViewPort({
      longitude: parseFloat(latLng[1]),
      latitude: parseFloat(latLng[0]),
    });
    setVisible(false);
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick, true);
    return () => document.removeEventListener("click", handleOutsideClick, true);
  }, []);

  return (
    <div className="h-10 iranSans absolute top-4 inset-x-4 rounded-xl z-20 bg-white" style={{ width: "calc(100% - 32px)" }}>
      <div ref={targetComponentRef} onClick={() => setVisible(true)}>
        <input
          name="searchLocation"
          value={state.searchLocation}
          className="w-full h-10 relative rounded-xl outline-none placeholder-grey-300 text-[11px] text-grey-700 pr-10"
          placeholder="جستجو"
          onChange={handleChangeSearchLocation}
          autoComplete="off"
          style={{ direction: "rtl" }}
        />
      </div>

      <div onClick={() => resetState()} className="absolute right-4 top-3">
        <SearchIconOutline width={16} height={16} fill={colors.grey[600]} />
      </div>

      {visible && (
        <button className="absolute left-4 inset-y-2 bg-transparent" onClick={() => resetState()}>
          <CloseIconOutline width={16} height={16} stroke={colors.grey[600]} />
        </button>
      )}

      {visible && (
        <div className="h-[316px] relative bg-white rounded-xl text-right overflow-y-scroll mt-2">
          <div className="w-full" style={{ direction: "rtl" }}>
            {state.searchLocationResults.map((location, index) => (
              <div key={location.id || index} className="flex items-start px-4 cursor-pointer" onClick={() => handleSelectLocation(location)}>
                <div className="flex flex-row items-center">
                  <p className="text-xs font-medium text-grey-800 pr-1">{location?.geo_location?.title} <span>-</span></p>
                  <p className="text-xs text-grey-600 my-2 mr-1">{location?.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default memo(MapSearch);
